export const keyEnter = 13;
export const keyF = 70;
